import { render, staticRenderFns } from "./ResendEmail2.vue?vue&type=template&id=89dd7244&scoped=true&"
import script from "./ResendEmail2.vue?vue&type=script&lang=js&"
export * from "./ResendEmail2.vue?vue&type=script&lang=js&"
import style0 from "./ResendEmail2.vue?vue&type=style&index=0&id=89dd7244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dd7244",
  null
  
)

export default component.exports